import { ColumnTable, Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReliquidationCourse } from '../../../types/tuitionContinuityV2';

const prefix = 'tuitionContinuityV2.reliquidation';

interface ReliquidationCoursesProps {
  courses: ReliquidationCourse[];
  totalCredits: number;
}

export default function ReliquidationCourses({
  courses,
  totalCredits,
}: ReliquidationCoursesProps) {
  const { t } = useTranslation();

  const columns = useMemo<ColumnTable<ReliquidationCourse>[]>(
    () => [
      {
        columnName: 'semesterName',
        headerText: t(`${prefix}.columnLevel`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'credits',
        headerText: t(`${prefix}.columnCredits`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
    ],
    [t],
  );

  const dataWithTotal = useMemo(() => {
    if (!courses.length) return [];
    return [
      ...courses,
      {
        name: '',
        semesterName: t(`${prefix}.totalCredits`),
        credits: totalCredits,
      } as ReliquidationCourse,
    ];
  }, [courses, totalCredits, t]);

  if (!courses.length) {
    return null;
  }

  return (
    <div className="mt-4">
      <p className="fs-20 text-uppercase text-primary fw-700">
        {t(`${prefix}.title`)}
      </p>
      <p className="fs-16 fw-300 mb-3">{t(`${prefix}.description`)}</p>
      <Table columns={columns} data={dataWithTotal} />
    </div>
  );
}
